import Main from '../components/Main';
import SearchCard from '../components/SearchCard';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from '../axiosConfig';
import '../assets/styles/Search.css';


// Search Page

const Search = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('query');
  const [results, setResults] = useState([]);

  useEffect(() => {
    const fetchResults = async () => {
      if (query) {
        try {
          
          const response = await axios.get('/api/search', {
            params: { search: query },
          });
          
          setResults(response.data);
        } catch (error) {
          console.error('Error fetching search results:', error);
        }
      }
    };

    fetchResults();
  }, [query]);

  const getBackgroundColor = (type) => {
    switch (type) {
      case 'publication': return '#FFDDC1'; // Pastel orange
      case 'project': return '#C1FFD7'; // Pastel green
      case 'request': return '#C1E1FF'; // Pastel blue
      case 'exec': return '#F4C2C2'; // Pastel red
      default: return '#F0F0F0'; // Default gray
    }
  };


  return (
    <Main componentList={[
      <div key="search-results">
        <h1>Résultats de la recherche pour : "{query}"</h1>
        {results.length > 0 ? (
          <div className="search-grid">
            {results.map((item, index) => (
              <div 
                key={index} 
                className="search-card-container" 
                style={{ backgroundColor: getBackgroundColor(item.type) }}
              >
                <SearchCard data={item} />
              </div>
            ))}
          </div>
        ) : (
          <p>Aucun résultat trouvé.</p>
        )}
      </div>
    ]} />
  );
};

export default Search;